export const getHrisDisplayName = (
  mergeIntegration: MergeIntegration | null | undefined,
  hrisIntegrationResponse: HrisIntegrationResponse | null | undefined,
) => {
  const isSyncingWithInova =
    hrisIntegrationResponse?.HrisIntegrationType?.integrationName === 'Inova' &&
    mergeIntegration?.HrisIntegrationType?.integrationName === 'UKG Ready';

  return isSyncingWithInova ? 'Inova' : mergeIntegration?.HrisIntegrationType?.integrationName;
};
